import { render } from "./TheAside.vue?vue&type=template&id=86d36364"
import script from "./TheAside.vue?vue&type=script&lang=js"
export * from "./TheAside.vue?vue&type=script&lang=js"

import "./TheAside.vue?vue&type=style&index=0&id=86d36364&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__